import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import { request } from "http";
import {
  addDislike,
  addLike,
  refreshCard,
  removeDislike,
  removeLike,
  setUserBookmarks,
  updateBookmarkLocal,
  updateVotes,
} from "./PublicCollectionsDataSlice";
import { setAdditionalKeys } from "./PublicPageDataSlice";
interface ModalDataState {
  loading: boolean;
  error: string | null;
  isLogin: any;
  lastLiked: any;
  lastDisliked: any;
  isLiked: any;
  isDisliked: any;
  userInteractionProcessing: any;
}


const initialState: ModalDataState = {
  loading: false,
  error: null,
  isLogin: false,
  lastLiked: null,
  lastDisliked: null,
  isLiked: null,
  isDisliked: null,
  userInteractionProcessing: false,
};

export const addBookmark = createAsyncThunk(
  "userActions/addBookmark",
  async (requestData: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await fetch(
        "https://www.notablehq.com/wp-json/nhq/v1/me/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`,
          },
          credentials: "omit",
          body: JSON.stringify({
            save_collection: {
              collection_id: requestData.id,
              type: requestData.type,
            },
          }),
        }
      );
      // console.log(requestData.type);

      if (response.ok) {
        dispatch(setUserInteractionProcessing(false));
        dispatch(refreshCard());
        dispatch(setAdditionalKeys());
      }
      if (!response.ok) {
        throw new Error("Failed to Add Bookmark");
      }

      const result = await response.text();
      return result;
    } catch (error: any) {
      let state: any = getState();
      let { lastBookmark, userBookmarks } = state.publicCollectionsData;

      let id = requestData.id;
      let failedChecked = requestData.type;
      let checkedValues = lastBookmark[id];

      dispatch(updateBookmarkLocal({ id, checkedValues }));
      
      dispatch(refreshCard());
      dispatch(setAdditionalKeys());
      dispatch(setUserInteractionProcessing(false));
      return rejectWithValue(error.message);
    }
  }
);
export const likeCollection = createAsyncThunk(
  "userActions/likeCollection",
  async (requestData: any, { rejectWithValue, dispatch, getState }) => {

    const state:any = getState();
    const {likedCollections, dislikedCollections, userBookmarks, isLogin} = state.publicCollectionsData;
    const isUserLoggedIn = true;
    const {collections} = state.authorCollections;
    try {
      const response = await fetch(
        "https://www.notablehq.com/wp-json/nhq/v1/me/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`,
          },
          credentials: "omit",
          body: JSON.stringify({
            like: {
              collection_id: requestData,
            },
          }),
        }
      );

      // let { searchValue, sortBy, page, perpage, likedCollections, dislikedCollections} = state.publicCollectionsData;

      if (response.ok) {
        dispatch(setUserInteractionProcessing(false));
        // dispatch(refreshCard());
        // dispatch(setAdditionalKeys());
      }
      
      if (!response.ok) {
        dispatch(refreshCard());
        dispatch(setAdditionalKeys());
        throw new Error("Failed to like collection");
      }

      const result = await response.text();
      return result;

    } catch (error: any) {
      let state: any = getState();
      let { lastLiked, lastDisliked } = state.userActions;

      if (lastLiked === requestData) {
        dispatch(addLike(requestData));
        dispatch(updateVotes({ id: requestData, payload: +1 }));
      }
      if (lastDisliked === requestData) {
        dispatch(addDislike(requestData));
        dispatch(updateVotes({ id: requestData, payload: -2 }));
      }
      if (lastLiked !== requestData && lastDisliked !== requestData) {
        dispatch(removeLike(requestData));
        dispatch(updateVotes({ id: requestData, payload: -1 }));
      }
      dispatch(refreshCard());
      dispatch(setAdditionalKeys());
      dispatch(setUserInteractionProcessing(false));
      return rejectWithValue(error.message);
    }
  }
);

export const dislikeCollection = createAsyncThunk(
  "userActions/dislikeCollection",
  async (requestData: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await fetch(
        "https://www.notablehq.com/wp-json/nhq/v1/me/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`,
          },
          credentials: "omit",
          body: JSON.stringify({
            dislike: {
              collection_id: requestData,
            },
          }),
        }
      );

      if (response.ok) {
        dispatch(setUserInteractionProcessing(false));
      }

      if (!response.ok) {
        dispatch(refreshCard());
        dispatch(setAdditionalKeys());
        throw new Error("Failed to dislike collection");
      }

      const result = await response.text();
      return result;
    } catch (error: any) {
      let state: any = getState();
      let { lastLiked, lastDisliked } = state.userActions;

      if (lastDisliked === requestData) {
        dispatch(addDislike(requestData));
        dispatch(updateVotes({ id: requestData, payload: -1 }));
      }
      if (lastLiked === requestData) {
        dispatch(addLike(requestData));
        dispatch(updateVotes({ id: requestData, payload: +2 }));
      }
      if (lastDisliked !== requestData && lastLiked !== requestData) {
        dispatch(removeDislike(requestData));
        dispatch(updateVotes({ id: requestData, payload: +1 }));
      }

      dispatch(refreshCard());
      dispatch(setAdditionalKeys());
      dispatch(setUserInteractionProcessing(false));
      return rejectWithValue(error.message);
    }
  }
);

const userActionsSlice = createSlice({
  name: "userActions",
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    addLastLiked: (state, action) => {
      state.lastLiked = action.payload;
    },
    addLastDisliked: (state, action) => {
      state.lastDisliked = action.payload;
    },
    setUserInteractionProcessing: (state, action) => {
      state.userInteractionProcessing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(likeCollection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(likeCollection.fulfilled, (state) => {
        state.loading = false;
        state.userInteractionProcessing = false;
        // message.success("Collection Liked", 1)
      })
      .addCase(likeCollection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.userInteractionProcessing = false;
        message.error("Like Failed", 1);
      })
      .addCase(dislikeCollection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dislikeCollection.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(dislikeCollection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        message.error("Dislike Failed", 1);
      })
      .addCase(addBookmark.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addBookmark.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addBookmark.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        message.error("Bookmarks Request Failed", 1);
      });
  },
});

export default userActionsSlice.reducer;

export const {
  setLogin,
  addLastDisliked,
  addLastLiked,
  setUserInteractionProcessing,
} = userActionsSlice.actions;

export const handleLike: any = createAsyncThunk(
  "userActions/handleLike",
  async (id: any, { getState, dispatch, rejectWithValue }) => {
    dispatch(setUserInteractionProcessing(true));

    let state: any = getState();
    let { likedCollections, dislikedCollections } = state.publicCollectionsData;
    let { isLiked, isDisliked } = state.userActions;

    dispatch(likeCollection(id));

    isLiked = likedCollections.some((item: any) => item === id);
    isDisliked = dislikedCollections.some((item: any) => item === id);

    
    if (isLiked) {
      dispatch(removeLike(id));
      dispatch(addLastLiked(id));
      dispatch(updateVotes({ id: id, payload: -1 }));
    } else if (isDisliked) {
      dispatch(addLike(id));
      dispatch(addLastDisliked(id));
      dispatch(updateVotes({ id: id, payload: +2 }));
    } else {
      dispatch(addLike(id));
      dispatch(addLastDisliked(null));
      dispatch(addLastLiked(null));
      dispatch(updateVotes({ id: id, payload: +1 }));
    }

    dispatch(refreshCard(""));
    dispatch(setAdditionalKeys());
  }
);

export const handleDislike: any = createAsyncThunk(
  "userActions/handleDislike",
  async (id: any, { getState, dispatch, rejectWithValue }) => {
    dispatch(setUserInteractionProcessing(true));

    let state: any = getState();
    let { likedCollections, dislikedCollections } = state.publicCollectionsData;
    let { isLiked, isDisliked } = state.userActions;

    dispatch(dislikeCollection(id));

    isLiked = likedCollections.some((item: any) => item === id);
    isDisliked = dislikedCollections.some((item: any) => item === id);

    if (isDisliked) {
      dispatch(removeDislike(id));
      dispatch(addLastDisliked(id));
      dispatch(updateVotes({ id: id, payload: +1 }));
    } else if (isLiked) {
      dispatch(addDislike(id));
      dispatch(addLastLiked(id));
      dispatch(updateVotes({ id: id, payload: -2 }));
    } else {
      dispatch(addDislike(id));
      dispatch(addLastDisliked(null));
      dispatch(addLastLiked(null));
      dispatch(updateVotes({ id: id, payload: -1 }));
    }

    dispatch(refreshCard(""));
    dispatch(setAdditionalKeys());
  }
);
